import React, { Component, useState, Fragment } from "react";
import { TopTextReusableComponent } from "../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import Form from "react-bootstrap/Form";
import {
  NewInputText,
  SelectBoxMUiInputComponent,
} from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import {
  ReusableOnboardingLink,
  ReusableOnboardingButton,
  ReusableOnboardingMapButton,
} from "../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import InputNumberFunc from "../../../../function/InputNumberFunc";
import SuggestNewButton from "../../reusableOnboardingPopupComponent/suggestNew/SuggestNewButton";
import isEmpty from "../../../../store/validation/is-Empty";
import { Toggle } from "../../../superAdminComponents/superAdminReusable/reusableSuperAdminButton/Toggle";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { create_and_update_restaurant } from "../../../../store/actions/authAction";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import { RestaurantTypeValidation } from "../../../../store/validation/allValidationFile/onboardingProcessValidation/RestaurantTypeValidation";
import { SliderReusableComponent } from "../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { BackLogoIconButton } from "../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import Media from "react-media";
import { SliderMobileReusableComponent } from "../../../reusableComponents/sliderReusableComponent/SliderMobileReusableComponent";
import { MobileTopHeader } from "../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import { TextField } from "@material-ui/core";
import { Button, Modal } from "react-bootstrap";

const revenueData = [
  { id: 1, name: "0 - 1 Lakhs", value: "0 - 1 Lakhs" },
  { id: 2, name: "1 - 5 Lakhs", value: "1 - 5 Lakhs" },
  { id: 3, name: "5 - 10 Lakhs", value: "5 - 10 Lakhs" },
  { id: 4, name: "10 - 15 Lakhs", value: "10 - 15 Lakhs" },
  { id: 5, name: "15 - 20 Lakhs", value: "15 - 20 Lakhs" },
  { id: 6, name: "20 - 50 Lakhs", value: "20 - 50 Lakhs" },
  { id: 7, name: "1 Cr and Above", value: "1 Cr and Above" },
];

export class RestaurantTypeComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      actionButton: false,
      selectedTab: 2,
      all_restauranttype_icons: [],
      selected_restaurant_type: [],
      primary_restaurant_type: {},
      cost_for_two: "",
      openRevenueModel: false,
      revenue: "",
      vegOnly: false,
      revenueError: false,
      errors: {},
      formShow: false,
      showRevenue: false,
    };
  }

  componentDidMount() {
    if (this.props.auth.loader) {
      this.setState({
        loader: true,
      });
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      !isEmpty(nextProps.onboarding._id) &&
      !isEmpty(nextProps.restaurant_type) &&
      !nextState.hasSetMapProps
    ) {
      let selected_restaurant_type =
        nextProps.onboarding.selected_restaurant_type;
      let primary_restaurant_type =
        nextProps.onboarding.primary_restaurant_type;
      if (
        !isEmpty(nextProps.onboarding.primary_restaurant_type) &&
        !isEmpty(selected_restaurant_type[0])
      ) {
        if (
          nextProps.onboarding.primary_restaurant_type !== "" &&
          isEmpty(selected_restaurant_type[0]._id) &&
          selected_restaurant_type.length > 0 &&
          isEmpty(primary_restaurant_type._id)
        ) {
          selected_restaurant_type = nextProps.restaurant_type.filter(
            (restaurant) => selected_restaurant_type.includes(restaurant._id)
          );
          primary_restaurant_type = nextProps.restaurant_type.filter(
            (restaurant) => restaurant._id === primary_restaurant_type
          )[0];
        }
      }
      let all_restaurants = nextProps.restaurant_type.filter(
        (restaurant) =>
          !selected_restaurant_type.some(
            (selected) => selected._id === restaurant._id
          ) && restaurant.status !== "NOTAPPROVED"
      );
      return {
        all_restauranttype_icons: all_restaurants,
        selected_restaurant_type: !isEmpty(selected_restaurant_type)
          ? selected_restaurant_type
          : [],
        primary_restaurant_type: !isEmpty(primary_restaurant_type)
          ? primary_restaurant_type
          : {},
        vegOnly: !isEmpty(nextProps.onboarding.vegOnly)
          ? nextProps?.onboarding?.vegOnly
          : false,
        cost_for_two: nextProps.onboarding.cost_for_two
          ? nextProps.onboarding.cost_for_two
          : "",
        revenue: nextProps.onboarding.revenue
          ? nextProps.onboarding.revenue
          : "",
        hasSetMapProps: true,
      };
    }
    if (nextProps.auth.loader !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
      };
    }
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextProps.errors,
      };
    }
    return null;
  }

  onRevenueModel = () => {
    this.setState({
      openRevenueModel: true,
      revenueError: true,
    });
  };

  onRevenueCloseModel = () => {
    this.setState({
      openRevenueModel: false,
      revenueError: true,
    });
  };

  onVegOnlyClicked = (e) => {
    this.setState({ vegOnly: !this.state.vegOnly, actionButton: true });
  };

  onRevenueButtonClick = (e, type) => {
    e.preventDefault();
    this.setState({
      revenue: type,
      openRevenueModel: false,
      revenueError: false,
    });
  };

  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  onChange = (e) => {
    const { value, maxLength } = e.target;
    const number = value.slice(0, maxLength);
    this.setState({
      [e.target.name]: number,
      actionButton: true,
    });
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[e.target.name] = `${e.target.name} is required`;
    } else {
      delete errors[e.target.name];
    }
    this.setState({
      errors: errors,
      actionButton: true,
    });
  };

  /****************************************
   * @DESC - Restaurant SELECTOR
   ****************************************/
  onRestaurantSelectorArraySelector = (icon, index) => (e) => {
    let buttonArray = this.state.all_restauranttype_icons;
    buttonArray.splice(index, 1);
    let Restaurant = this.state.selected_restaurant_type;
    let primaryIcon = this.state.primary_restaurant_type;
    if (Restaurant.length === 0 || primaryIcon === {}) {
      Restaurant.push(icon);
      this.setState({
        selected_restaurant_type: Restaurant,
        primary_restaurant_type: icon,
        actionButton: true,
      });
    } else {
      let isAlreadyPresent = Restaurant.includes(icon);
      if (isAlreadyPresent) {
        let indexOf = Restaurant.indexOf(icon);
        if (indexOf === 0 || indexOf) {
          Restaurant.splice(indexOf, 1);
        }
      } else {
        Restaurant.push(icon);
      }
    }
    this.setState({
      selected_restaurant_type: Restaurant,
      actionButton: true,
    });
  };

  onRestaurantsPrimarySelector = (icon) => (e) => {
    this.setState({
      primary_restaurant_type: icon,
      actionButton: true,
    });
  };

  /****************************************
   * @DESC - Remove Primary button handler
   ****************************************/
  removeButton = (icon) => (e) => {
    let all_restauranttype_icons = this.state.all_restauranttype_icons;
    let selected_restaurant_type = this.state.selected_restaurant_type;
    let primary_restaurant_type = this.state.primary_restaurant_type;

    let iconIndexAtAllIcons = all_restauranttype_icons.findIndex(
      (icons) => icons._id === icon._id
    );
    let iconIndexAtSelectedIcons = selected_restaurant_type.findIndex(
      (icons) => icons._id === icon._id
    );
    let iconAtPrimaryIcon =
      !isEmpty(primary_restaurant_type) &&
      primary_restaurant_type._id === icon._id
        ? true
        : false;
    if (selected_restaurant_type.length === 0) {
      selected_restaurant_type.push(icon);
      all_restauranttype_icons.splice(iconIndexAtAllIcons, 1);
      primary_restaurant_type = icon;
    } else if (iconAtPrimaryIcon) {
      selected_restaurant_type.splice(iconIndexAtSelectedIcons, 1);
      all_restauranttype_icons.push(icon);
      if (selected_restaurant_type.length === 1) {
        console.log("IN OR");
        primary_restaurant_type = selected_restaurant_type[0];
      } else {
        primary_restaurant_type = {};
      }
    } else if (iconIndexAtSelectedIcons === 0 || iconIndexAtSelectedIcons) {
      selected_restaurant_type.splice(iconIndexAtSelectedIcons, 1);
      all_restauranttype_icons.push(icon);
      if (selected_restaurant_type.length === 1) {
        primary_restaurant_type = selected_restaurant_type[0];
      }
    } else {
      selected_restaurant_type.push(icon);
      all_restauranttype_icons.splice(iconIndexAtAllIcons, 1);
    }

    this.setState({
      selected_restaurant_type: selected_restaurant_type,
      all_restauranttype_icons: all_restauranttype_icons,
      primary_restaurant_type: primary_restaurant_type,
      actionButton: true,
    });
  };

  onWithOutApiCall = (e) => {
    this.props.history.push({
      pathname: "/paymenttype",
    });
  };

  onHandleSubmit = (e) => {
    e.preventDefault();
    const { errors, isValid } = RestaurantTypeValidation(this.state);
    if (!isValid) {
      this.setState({
        errors: errors,
      });
    } else {
      if (
        this.props.onboarding &&
        this.props.onboarding.selected_restaurant_type.length > 0
      ) {
        const formData = {
          vendor_id: this.props.onboarding.vendor_id,
          id: this.props.onboarding._id,
          selected_restaurant_type: this.state.selected_restaurant_type,
          primary_restaurant_type: this.state.primary_restaurant_type,
          vegOnly: this.state.vegOnly,
          cost_for_two: this.state.cost_for_two,
          revenue: this.state.revenue,
        };
        this.props.create_and_update_restaurant(formData);
        this.props.history.push("/paymenttype");
      } else {
        const formData = {
          vendor_id: this.props.onboarding.vendor_id,
          id: this.props.onboarding._id,
          selected_restaurant_type: this.state.selected_restaurant_type,
          primary_restaurant_type: this.state.primary_restaurant_type,
          vegOnly: this.state.vegOnly,
          cost_for_two: this.state.cost_for_two,
          revenue: this.state.revenue,
          page_completed_till: 6,
        };
        this.props.create_and_update_restaurant(formData);
        this.props.history.push("/paymenttype");
      }
    }
  };
  handleClose = () => {
    this.setState({ showRevenue: false });
  };

  renderButtonsandFields = () => {
    let {
      actionButton,
      errors,
      selected_restaurant_type,
      revenue,
      cost_for_two,
      primary_restaurant_type,
      vegOnly,
    } = this.state;
    return (
      <React.Fragment>
        <div className="restaurant_type_onboarding_main">
          <div className="onboarding_process_screen-button-map onboarding_process_screen-left-mapinside">
            <div className="cuisine-main restaurant-type-display-mobile-margin mb-0">
              <div
                className={
                  this.state.all_restauranttype_icons.length > 8
                    ? "cuisine-main-padding-border"
                    : ""
                }
              >
                <div
                  id="box-style"
                  className="cuisine-main-padding column-2"
                  style={{ display: "flex", flexWrap: "wrap" }}
                >
                  {this.state.all_restauranttype_icons.map((icon, index) => (
                    <ReusableOnboardingMapButton
                      key={index}
                      classsection="onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                      src={icon.icon}
                      title={icon.title}
                      onClick={this.onRestaurantSelectorArraySelector(
                        icon,
                        index
                      )}
                    />
                  ))}
                </div>
              </div>
              <div className="suggest-button-heading">
                <SuggestNewButton categoryId={"5f562c9094ac7fdf47ea1d0a"} />
              </div>

              {/** */}
              {!isEmpty(selected_restaurant_type) ? (
                <React.Fragment>
                  <div className="f14-500 mt-4">
                    Out of the selections below, which one is primary?
                  </div>
                  <div className="f12-500 opacity5">
                    Select only one of the options below as a default - this is
                    shown to the user.
                  </div>
                </React.Fragment>
              ) : null}

              <div
                // id="box-style"
                className="cuisine-main-padding-bottom column-2 mt-4"
                style={{ display: "flex", flexWrap: "wrap" }}
              >
                {selected_restaurant_type.map((icon, index) => (
                  <ReusableOnboardingMapButton
                    key={index}
                    classsection={
                      // icon._id === primary_restaurant_type._id
                      //   ?
                      "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_active_two onboarding_mapbutton_reusable_type"
                      // : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_active"
                    }
                    src={icon.icon}
                    title={icon.title}
                    onClick={this.onRestaurantsPrimarySelector(icon)}
                    displayPrimary={
                      icon._id === primary_restaurant_type._id ? true : false
                    }
                    displayRemove={true}
                    removeButtonClick={this.removeButton(icon, index)}
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="onboarding_process_screen-button-map onboarding_process_screen-left-mapinside">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h4 className="f16-500">
                  Is your restaurant a veg-only restaurant?
                </h4>
                <p className="f10-400 opacity5">
                  Enable this toggle if you serve only veg food items at your
                  restaurant
                </p>
              </div>
              <div className="col-md-4 text-center">
                <Toggle
                  checked={this.state?.vegOnly}
                  toggleFunction={this.onVegOnlyClicked}
                />
              </div>
            </div>
          </div>
          <div className="col-12 onboarding_process_screen-left-mapinside">
            <div className="restaurant_type_onboarding_main_section mobile-mt-4">
              <div className="col-12 pl-0 restaurant_type_onboarding_main_sectionone">
                <div className="f12-500">Avg. Cost for Two? </div>
                <div className="f10-500">
                  Cost of dining at your place this is required information{" "}
                </div>
              </div>
              <div className="col-6 col-sm-6 col-md-5 col-lg-5 col-xl-5 pl-0 mt-4 restaurant_type_onboarding_main_sectiontwo">
                {/* {this.state.cost_for_two && ( */}
                <div className="rupees-icon-input">
                  <i className="fa fa-inr" aria-hidden="true"></i>
                </div>
                {/* )} */}
                <NewInputText
                  extraClass="mb-0 new-image-class-input cost_of_two"
                  name="cost_for_two"
                  inputType="number"
                  maxLength={6}
                  onChange={this.onChange}
                  onFocusOut={this.onFocusOut}
                  onKeyDown={InputNumberFunc}
                  value={this.state.cost_for_two}
                  errorText={
                    errors.cost_for_two === "cost_for_two is required"
                      ? "cost for two is required"
                      : null
                  }
                  errorTrue={
                    errors.cost_for_two === "cost_for_two is required"
                      ? true
                      : false
                  }
                  // labelText="Cost For Two"
                  controlClass={
                    errors.cost_for_two === "cost_for_two is required"
                      ? "outlined-error-helper-text"
                      : "outlined-number"
                  }
                />
              </div>
            </div>
            {/* </div>
          <div className="col-12 onboarding_process_screen-left-mapinside"> */}
            <div className="restaurant_type_onboarding_main_section margin-bottom-chains-onboarding mb-md-5 mb-lg-5 mb-xl-5">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pl-0 mb-4 restaurant_type_onboarding_main_sectionone">
                <div className="f12-500">Revenue (Yearly)</div>
                <div className="f11-400 opacity5">
                  ( Select from approx annual revenue range for your place )
                </div>
              </div>
              <Media query="(min-width: 992px)">
                <div
                  id="revenue-text"
                  className="col-9 col-sm-9 col-md-9 col-lg-9 col-xl-9 pl-0 restaurant_type_onboarding_main_sectiontwo"
                >
                  {this.state.revenue && (
                    <div className="rupees-icon-input">
                      <i className="fa fa-inr" aria-hidden="true"></i>
                    </div>
                  )}
                  <SelectBoxMUiInputComponent
                    displayNone={true}
                    selectLabel="Revenue"
                    extraClass={true}
                    name="revenue"
                    value={this.state.revenue}
                    onChange={this.onChange}
                    getData={revenueData}
                    errorText={errors.revenue}
                    errorTrue={errors.revenue === "" ? true : false}
                  />
                </div>
              </Media>
              <Media query="(max-width: 992px)">
                <>
                  <div
                    id="revenue-text"
                    className="col-9 col-sm-9 col-md-9 col-lg-9 col-xl-9 pl-0 restaurant_type_onboarding_main_sectiontwo"
                  >
                    {this.state.revenue && (
                      <div className="rupees-icon-input">
                        <i className="fa fa-inr" aria-hidden="true"></i>
                      </div>
                    )}
                    <TextField
                      variant="outlined"
                      className="mb-0 new-image-class-input cost_of_two"
                      label="Revenue"
                      value={this.state.revenue}
                      // disabled={true}
                      onClick={() => {
                        this.setState({ showRevenue: true });
                      }}
                      fullWidth
                    />
                  </div>
                  <Modal
                    show={this.state.showRevenue}
                    onHide={this.handleClose}
                    centered
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Revenue (Yearly)</Modal.Title>
                    </Modal.Header>
                    <ModalBodyRevenue
                      revenueData={revenueData}
                      onChange={this.onChange}
                      revenue={this.state.revenue}
                      handleClose={this.handleClose}
                    />
                  </Modal>
                </>
              </Media>
            </div>
            {/* </div> */}
            <div className="onboarding-map-setup-screen-autodetect-button ">
              <Media query="(min-width: 992px)">
                <ReusableOnboardingLink
                  buttonTitle="Back Button"
                  buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                  buttonText="Back"
                  link="/restaurantchains"
                />
              </Media>
              <Media query="(max-width: 991px)">
                <ReusableOnboardingButton
                  buttonTitle="Back Button"
                  buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                  buttonText="Back"
                  buttonType="button"
                  onClick={this.handleFormHide}
                />
              </Media>
              <ReusableOnboardingButton
                buttonTitle="Next Button"
                buttonClass={
                  selected_restaurant_type.length <= 0 ||
                  isEmpty(primary_restaurant_type) ||
                  cost_for_two === "" ||
                  revenue === ""
                    ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray ml-3"
                    : "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                }
                disabled={
                  selected_restaurant_type.length <= 0 ||
                  isEmpty(primary_restaurant_type) ||
                  cost_for_two === "" ||
                  revenue === ""
                    ? true
                    : false
                }
                buttonText="Next"
                onClick={actionButton === false ? this.onWithOutApiCall : null}
                buttonType={actionButton === false ? "button" : "submit"}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };
  handleFormShow = () => {
    this.setState({ formShow: true });
  };
  handleFormHide = () => {
    this.setState({ formShow: false });
  };
  render() {
    if (this.state.loader) {
      return <AmealioLoader />;
    }
    const { formShow } = this.state;
    return (
      <React.Fragment>
        <Media query="(max-width: 991px)">
          <>
            {!formShow && (
              <div className="bg-white min-height-100vh position-relative">
                <div className="mobileFirstScreen col-12">
                  <SliderMobileReusableComponent
                    displayShow={true}
                    selectedProgressBarOne="active"
                    backLink={true}
                    onLink={"/restaurantchains"}
                    paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                    paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                    paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                    bottomImage={require("../../../../assets/images/illustratorImage/Amealio_Illustrations-06.svg")}
                  />
                </div>
                <div className="col-12 py-4">
                  <div className="f24_700_HelveticaNeue">Business Type</div>
                  {/* <div className="f16-400 opacity5">
                    Enter the details about your Business location
                  </div> */}
                </div>
                <div className="border-top d-flex justify-content-center align-items-center p-3 fixed-bottom bg-white">
                  <ReusableOnboardingLink
                    buttonTitle="Back Button"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                    buttonText="Back"
                    link={"/restaurantchains"}
                  />
                  <ReusableOnboardingButton
                    buttonType="button"
                    buttonTitle="Next"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                    buttonText="Next"
                    onClick={this.handleFormShow}
                  />
                </div>
              </div>
            )}
          </>
        </Media>
        <div className={`container-fluid formShow ${formShow ? "active" : ""}`}>
          <div className="row">
            <div
              id="onboarding-scrollbar"
              className="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left"
            >
              {/* <div className="col-12 onboarding_process_screen_left-backbutton">
                <NavLink to="/restaurantchains" className="back_button-link">
                  <Image
                    src={require("../../../../assets/images/Icon/onBoardBack.png")}
                    alt="Back Button"
                    title="Back Button"
                  />
                </NavLink>
              </div> */}

              <Media query="(min-width: 992px)">
                <div className="col-12">
                  <BackLogoIconButton
                    displayBackText={true}
                    displayArrow={true}
                    backButtonClicked={"/restaurantchains"}
                  />
                </div>
              </Media>
              <Media query="(max-width: 991px)">
                <MobileTopHeader onClick={this.handleFormHide} />
              </Media>
              {/* <div className="display-toggle-stepup-button">
                <RightSidePannel selectedTab={this.state.selectedTab} />
              </div> */}
              <div className="">
                <div className="onboarding_process_screen-left-mapinside">
                  <TopTextReusableComponent
                    headingText="Business Type"
                    headingParagraph="(Select the type of Business Establishment you are, you can select multiple and define one default - this is required info)"
                  />
                </div>
                <Form noValidate onSubmit={this.onHandleSubmit}>
                  {this.renderButtonsandFields()}
                </Form>
              </div>
            </div>
            <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
              <SliderReusableComponent
                displayBarButton={true}
                displayHamburger={true}
                selectedProgressBarOne="active"
                paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                bottomImage={require("../../../../assets/images/illustratorImage/Amealio_Illustrations-06.svg")}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

RestaurantTypeComponent.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  restaurant_type: state.category.restaurant_type,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  create_and_update_restaurant,
})(withRouter(RestaurantTypeComponent));

const ModalBodyRevenue = (props) => {
  const [value, setValue] = useState(props.revenue ? props.revenue : "");
  return (
    <Fragment>
      <Modal.Body>
        <div className="f12-500">Select one relevant option from below</div>
        <div className="row">
          {props.revenueData.map((data, index) => {
            return (
              <div className="col-6 " key={index}>
                <div
                  onClick={() => {
                    setValue(data.value);
                  }}
                  style={{
                    width: "100% !important",
                    minHeight: "50px",
                    backgroundColor: "#ffffff",
                    boxShadow: "0 3px 6px #00000033",
                    borderRadius: "5px",
                    display: "flex",
                    alignItems: "center",
                    padding: "10px 18px",
                    cursor: "pointer",
                    position: "relative",
                  }}
                  className={`m-1 onboarding_mapbutton_reusable_type ${
                    value === data.value &&
                    `onboarding_mapbutton_reusable_active_two`
                  }`}
                >
                  <div className="f10-400">{data.name}</div>
                </div>
              </div>
            );
          })}
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-content-start border-0">
        <Button
          variant="outline-secondary"
          className="btn-lg mr-4 px-5"
          onClick={props.handleClose}
        >
          Cancel
        </Button>
        <Button
          variant="danger"
          className="btn-lg px-5"
          onClick={() => {
            props.onChange({
              target: {
                value: value,
                name: "revenue",
              },
            });
            props.handleClose();
          }}
        >
          Confirm
        </Button>
      </Modal.Footer>
    </Fragment>
  );
};
